import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useSession } from './SessionProvider.js';
import { FullPageSpinner } from '../../components/FullPageSpinner.js';

interface LocationState {
  from?: string;
}

/**
 * Guarda rotas "públicas" que devem **não** ser acessíveis a usuários logados
 * (login, signup, reset). Se já tem sessão, redireciona para o destino
 * original (`location.state.from`) ou `/dashboard` como fallback.
 */
export function RequireGuest() {
  const { loading, session } = useSession();
  const location = useLocation();
  const state = location.state as LocationState | null;

  if (loading) return <FullPageSpinner />;
  if (session) {
    return <Navigate to={state?.from ?? '/dashboard'} replace />;
  }
  return <Outlet />;
}
